<template>
  <div
    class="metrics-values border-thick border-inverted border-bottom mt-3 pb-3 pr-2"
  >
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">Metrics</h2>
    <div v-if="newArticleDetailsDisplay" class="d-flex">
      <div
        class="metrics-values__altmetric-container font-smaller width-80"
        :class="
          displayIsDesktop && 'metrics-values__altmetric-container--float-left'
        "
      >
        <div
          class="altmetric-embed"
          data-badge-type="donut"
          :data-doi="doi"
          data-link-target="_blank"
          :data-hide-less-than="minimumScore"
        ></div>
      </div>
      <div
        class="font-smaller d-flex flex-wrap"
        :class="!showAltmetricBadge && 'width-100-minus-96'"
      >
        <div class="ml-2 pl-0 py-1 d-flex flex-column">
          <div class="d-inline-block text-right font-weight-bold">
            {{ abstractViewCount | localNumberWithZero }}
          </div>
          <div class="d-inline-block text-right font-weight-bold">
            {{ downloadsCount | localNumberWithZero }}
          </div>
          <div class="d-inline-block text-right font-weight-bold">
            {{ citationsCount | localNumberWithZero }}
          </div>
        </div>
        <div
          class="ml-2 pl-0 py-1 d-flex flex-column flex-grow-0 flex-shrink-0"
        >
          <div class="d-inline-block">Views</div>
          <div class="d-inline-block">Downloads</div>
          <div class="d-inline-block">
            <ArticleCitationsModal :article="article" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!newArticleDetailsDisplay"
      class="metrics-values__altmetric-container font-smaller width-96"
      :class="
        displayIsDesktop && 'metrics-values__altmetric-container--float-left'
      "
    >
      <div
        class="altmetric-embed"
        data-badge-type="donut"
        :data-doi="doi"
        data-link-target="_blank"
        :data-hide-less-than="minimumScore"
      ></div>
    </div>
    <div
      v-if="!newArticleDetailsDisplay"
      class="font-smaller"
      :class="!showAltmetricBadge && 'width-100-minus-96'"
    >
      <div class="ml-2 pl-0 py-1">
        <div
          class="d-inline-block"
          :class="isLargeNumber ? 'width-64' : 'width-48'"
        >
          {{ abstractViewCount | localNumberWithZero }}
        </div>
        <div class="d-inline-block">Views</div>
      </div>
      <div class="border-inverted border-top ml-2 pl-0 py-1">
        <div
          class="d-inline-block"
          :class="isLargeNumber ? 'width-64' : 'width-48'"
        >
          {{ downloadsCount | localNumberWithZero }}
        </div>
        <div class="d-inline-block">Content Downloads</div>
      </div>
      <div class="border-inverted border-top ml-2 pl-0 py-1">
        <div
          class="d-inline-block"
          :class="isLargeNumber ? 'width-64' : 'width-48'"
        >
          {{ citationsCount | localNumberWithZero }}
        </div>
        <div
          class="d-inline-block"
          :class="isLargeNumber ? 'width-64' : 'width-48'"
        >
          <ArticleCitationsModal :article="article" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import extractMetricsValue from "~/plugins/utilities/extractMetricsValue";
import ArticleCitationsModal from "~/components/articles/ArticleCitationsModal.vue";
import mapFlags from "~/plugins/utilities/mapFlags";

import { displayIsDesktop } from "~/components/utilities/displayBreakpoints";

export default {
  name: "MetricsValues",
  components: {
    ArticleCitationsModal,
  },
  props: {
    article: { type: Object, required: true },
  },
  data() {
    return {
      showAltmetricBadge: true,
    };
  },
  computed: {
    isLargeNumber() {
      return this.abstractViewCount > 99999;
    },
    displayIsDesktop,
    ...mapFlags(["newArticleDetailsDisplay"]),
    abstractViewCount() {
      return this.article.metrics
        ? extractMetricsValue(this.article.metrics, "ABSTRACT_VIEW_COUNT")
        : 0;
    },
    citationsCount() {
      return this.article.citationsCount;
    },
    downloadsCount() {
      return this.article.metrics
        ? extractMetricsValue(this.article.metrics, "MAIN_ITEM_DOWNLOAD_COUNT")
        : 0;
    },
    partner() {
      return this.$config.partner;
    },
    doi() {
      return this.article.doi;
    },
    minimumScore() {
      return 1;
    },
  },
  mounted() {
    this.$el.addEventListener("altmetric:hide", function () {
      this.showAltmetricBadge = false;
    });
  },
};
</script>

<style lang="scss">
.metrics-values {
  &__altmetric-container {
    &--float-left {
      float: left;
    }
  }
}
</style>
